import { api } from 'common';

import { SubFlowFormFields } from './FormFields';
import { getSubFlowBlockDefaultConfig } from './constants';
import { subFlowDocumentationMarkdown } from './documentation';
import { ProducedType } from '../../../../types';
import { type BlockConfigProps } from '../../../types';

export const subFlowV1Config: BlockConfigProps<api.FlowDefinition.SubFlowV1BlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'flowBlock',
  defaultConfig: getSubFlowBlockDefaultConfig(),
  returnType: ProducedType.SubFlowV1Result,
  configFields: {
    schema: api.FlowDefinition.SubFlowV1BlockConfigSchema,
    FormFields: SubFlowFormFields,
  },
  documentationMarkdown: subFlowDocumentationMarkdown,
};
